import {TenantNameResponse} from "@/types/service-response";

export default class TenantName {
    private constructor(
        readonly id: string,
        readonly key: string,
        readonly value: string
    ) {
    }

    public static createTenantName(responseNewName: TenantNameResponse): TenantName {
        return new TenantName(
            responseNewName.id,
            responseNewName.key,
            responseNewName.value
        )
    }
}